import $$api from 'models/api';
import { useEffect, useState } from 'react';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';

import 'components/pages/Dashboard/participants/AddObserver.scss';

import ModalsService from 'services/ModalsService';
import ParticipantsService from 'services/ParticipantsService';
import { phoneToWidgetFormat } from 'services/Utils';

import useResources from 'hooks/useResources';

import { type Document } from 'types/zod/document';
import { type Participant } from 'types/zod/participant';

interface AddObserverProps {
    documents: any[];
    tab: number;
    observers: Participant[];
}

const AddObserver = (props: AddObserverProps) => {
    const [allParticipants, setAllParticipant] = useState([] as Participant[]);
    const [participantsToShow, setParticipantsToShow] = useState([] as Participant[]);

    const { t } = useResources();

    useEffect(() => {
        (async () => {
            const participants = await $$api.participants.getParticipantsFx();
            setAllParticipant(participants);
        })();
    }, []);

    useEffect(() => {
        setParticipantsToShow(
            allParticipants.filter(
                (p) =>
                    p.participant_id !== props.tab &&
                    p.participant_type_code === 'Individual' &&
                    !props.observers.map((o) => o.participant_id).includes(p.participant_id),
            ),
        );
    }, [allParticipants, props.tab, props.observers]);

    const addObserver = (participant?: Participant) => {
        const popupData: any = participant
            ? {
                  ...participant,
                  phone_number: participant.phone_number ? phoneToWidgetFormat(participant.phone_number) : undefined,
              }
            : {};
        popupData.isObserver = true;
        popupData.roles = props.documents
            ?.filter?.((d: any) => {
                return d?.ownership?.includes?.(props.tab);
            })
            .map((d: Document) => {
                return {
                    document_id: d.document_id,
                    document_name: d.name,
                    document_status_code: d.document_status_code,
                    document_type_code: d.document_type_code,
                    group_mapping: 'Observer',
                    notifiable: true,
                    role_type_code: 'Observer',
                    visibility_code: 'participation_only',
                };
            });

        ModalsService.showModal('UPDATE_PARTICIPANT', popupData);
    };

    const handleDropdownSelect = (eventKey: string | null) => {
        if (!eventKey) return;
        if (eventKey === 'new') {
            addObserver();
        } else {
            addObserver(allParticipants.find((p) => p.participant_id === +eventKey));
        }
    };

    return (
        <>
            <DropdownButton
                as={ButtonGroup}
                className="dropdown-button mb-3"
                title={t('communityPage.selectOrAddAnObserver')}
                onSelect={handleDropdownSelect}
            >
                <Dropdown.Item eventKey="new" className="new-participant-option">
                    {t('communityPage.addNewObserver')}
                </Dropdown.Item>
                <Dropdown.Divider />
                {participantsToShow.map((p) => (
                    <Dropdown.Item key={p.participant_id} eventKey={'' + p.participant_id}>
                        {ParticipantsService.getFullName(p)}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
        </>
    );
};

export default AddObserver;
